"use client";
import "./homeAbout.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { slideIn, staggerContainer, staggerItem } from "@lib/motion";

const PILLS = [
  { key: "honesty", glyph: "⬡" },
  { key: "youFirst", glyph: "◈" },
  { key: "growing", glyph: "⊕" },
] as const;

export default function HomeAbout() {
  const t = useTranslations("home.about");

  return (
    <div id="home-about" className="home-about">
      <motion.div className="home-about-intro" {...slideIn("left")}>
        <p className="home-section-label">{t("label")}</p>
        <h2>
          {t("headlineTalk")}
          <br />
          {t("headlineAccompany")}
        </h2>
        <p className="home-about-body">{t("body")}</p>
      </motion.div>

      <motion.div className="home-about-pills" {...staggerContainer(0.6)}>
        {PILLS.map(({ key, glyph }) => (
          <motion.div key={key} className="home-pill" variants={staggerItem}>
            <span className="home-pill-glyph" aria-hidden="true">{glyph}</span>
            <span>
              <span className="home-pill-title">{t(`pills.${key}.title`)}</span>
              <span className="home-pill-desc">{t(`pills.${key}.desc`)}</span>
            </span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
